import { renderFieldInput as unifiedRenderFieldInput } from "@/components/shared/UniversalCRMTable/utils/unified-field-renderer";
import type { SimpleFieldConfig } from "../../UniversalCRMTable/types";

interface BulkEditFieldInputProps {
  fieldId: string;
  fieldConfig: SimpleFieldConfig;
  value: string;
  onValueChange: (value: string) => void;
}

export function BulkEditFieldInput({
  fieldId,
  fieldConfig,
  value,
  onValueChange,
}: BulkEditFieldInputProps) {
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-gray-700 dark:text-gray-300">New {fieldConfig.label}</label>
      {unifiedRenderFieldInput({
        fieldId,
        fieldConfig,
        value,
        onValueChange,
        fullWidth: true,
      })}
    </div>
  );
}
